import React from 'react';
import { Header } from '../components/Header';

export const PolicyPage = () => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12, padding: 12, maxWidth: 1200, margin: '0 auto' }}>
      <Header />

      <h1>Privacy Policy</h1>
      <p>Effective date: January 30, 2026</p>

      <p>Your privacy is important to us. This Privacy Policy explains how we collect, use, and protect your personal information when you use our website and related services, including integration with the YouTube API.</p>

      <h2>Information We Collect</h2>
      <p>We may collect the following types of information:</p>
      <ul>
        <li>Personal information you provide (e.g., name, email address)</li>
        <li>Information from your YouTube account when using YouTube APIs</li>
        <li>Usage data, such as pages visited or actions taken on our website</li>
      </ul>

      <h2>How We Use Your Information</h2>
      <p>We use the collected information to:</p>
      <ul>
        <li>Provide and improve our services</li>
        <li>Upload videos to our YouTube channel via our app (with your permission)</li>
        <li>Communicate with you about updates or service announcements</li>
        <li>Comply with legal obligations</li>
      </ul>

      <h2>Google User Data Retention and Deletion</h2>
      <p>
        We retain Google user data only for as long as necessary to provide our services.
        Any Google account information or YouTube data accessed through Google APIs is
        stored securely and is automatically deleted within 30 days after it is no longer
        required for service functionality, or upon user request, whichever comes first.
      </p>
      <p>
        Users may request deletion of their Google-related data at any time by contacting us.
        Upon verified request, we will delete applicable stored data within 30 days unless
        retention is required for legal or security purposes.
      </p>

      <h2>Data Sharing</h2>
      <p>We do not sell or rent your personal information. We may share data with:</p>
      <ul>
        <li>Service providers who help us operate the app and website</li>
        <li>Law enforcement or government agencies when required by law</li>
      </ul>

      <h2>Data Security</h2>
      <p>We implement reasonable measures to protect your information from unauthorized access, alteration, disclosure, or destruction. However, no online system can be 100% secure.</p>

      <h2>Third-Party Services</h2>
      <p>Our app may use third-party services, such as Google APIs, which have their own privacy policies. Please review their policies as well:</p>
      <ul>
        <li><a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer">Google Privacy Policy</a></li>
      </ul>

      <h2>Changes to This Policy</h2>
      <p>We may update this Privacy Policy from time to time. Updates will be posted on this page with the effective date.</p>

      <h2>Contact Us</h2>
      <p>If you have any questions about this Privacy Policy, please contact us at: <a href="mailto:info@nhenews.com">info@nhenews.com</a></p>
    </div>
  );
};
